{
  "quickAdd": {
    "placeholder": "What do you need to do?",
    "submit": "Add",
    "processing": "Thinking...",
    "added": "Added."
  }
}
